import { Link } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";

export const FinalCTA = () => (
  <section className="px-4 sm:px-6 py-16 bg-gray-900">
    <div className="max-w-3xl mx-auto text-center">
      <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-amber-400 mb-4">
        Limited Onboarding Spots This Week
      </span>
      <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-white">
        Ready to Meet Your Perfect Trading Platform?
      </h2>
      <p className="text-base md:text-lg text-gray-400 mt-4">
        Complete your 60-second profile and let the AI do the rest. Our team will guide your account activation within 24 hours.
      </p>

      <div className="mt-10 grid grid-cols-3 gap-px bg-gray-800 border border-gray-800 rounded-2xl overflow-hidden max-w-lg mx-auto">
        {[
          { v: "96.4%", l: "Match Rate" },
          { v: "200+", l: "Platforms" },
          { v: "12,400+", l: "Users" },
        ].map((s, i) => (
          <div key={i} className="bg-gray-900 py-6 px-2">
            <p className="font-heading text-2xl font-bold text-white">{s.v}</p>
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 mt-1">{s.l}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 flex justify-center">
        <Link
          to="/confirmation"
          data-testid="final-cta-btn"
          className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-bold px-10 py-4 rounded-full text-sm transition-all duration-200 hover:scale-105"
        >
          Activate My Account
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <p className="mt-5 flex items-center justify-center gap-2 text-xs text-gray-500">
        <Lock className="w-3.5 h-3.5" />
        Bank-level encryption · Your data is never sold or shared
      </p>
    </div>
  </section>
);
